module.exports = __webpack_public_path__ + "static/media/home_img_bottom.3b992c1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_img_bottom.png
// module id = 277
// module chunks = 14